// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-card-container{align-items:center;border-radius:.25rem;display:flex;flex-direction:column;height:75px;justify-content:center;min-width:75px;transition:all 150ms ease-out}.file-card-container:hover,.file-card-container:focus{cursor:pointer;filter:brightness(1.15)}.file-card-container .file-card-image-thumbnail{border-radius:.25rem;height:75px;object-fit:contain;width:75px}\n", ""]);
// Exports
module.exports = exports;
